import { ToggleNetworkLoadingSpinnerVisibilityAction, LoadingSpinnerState } from "./type";

export function toggleNetworkLoadingSpinnerVisibilityHandler(state: LoadingSpinnerState, action: ToggleNetworkLoadingSpinnerVisibilityAction) {
    return Object.assign({}, state, { ...action.payload});
}


// WEBPACK FOOTER //
// ./src/store/LoadingSpinner/handlers.ts